import React from 'react'
import { Box, Flex, Grid } from '@chatterbug/aaron'

export type Props = {
  title: string
  subtitle: string
  image: {
    url: string
    width: number
    height: number
  }
}

const PageWrapupCelebration: React.FC<Props> = ({ title, subtitle, image }) => {
  return (
    <Grid columns={{ _: '1fr', tablet: '1fr 1fr' }} gap="2x">
      <Box textAlign={{ _: 'center', tablet: 'left' }}>
        <Box as="h1" variant="text.h4" mb="2x" lineHeight={1.2}>
          {title}
        </Box>
        <Box
          as="h2"
          variant="text.h2"
          lineHeight={1.2}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      </Box>
      <Flex justifyContent="center">
        <Box width={image.width} height={image.height}>
          <object type="image/svg+xml" data={image.url} aria-hidden="true" />
        </Box>
      </Flex>
    </Grid>
  )
}

export default PageWrapupCelebration
